<template>
  <div>
    <titulo-modulo titulo="Manuais" />
    <v-progress-linear indeterminate v-if="carregando"></v-progress-linear>
    <template v-else>
      <v-card flat v-for="(manual, i) in manuais" :key="i" class="mt-2 mb-2 rounded-lg">
        <v-card-title class="pb-0 font-weight-bold">{{
          manual.titulo
        }}</v-card-title>
        <v-card-text v-text="manual.descricao"></v-card-text>
        <v-card-actions class="pb-5">
          <v-btn
            rounded
            color="info"
            min-width="200"
            max-height="35"
            :block="$mq === 'sm'"
            target="blank"
            :href="manual.link"
            depressed
            >Visualizar Manual</v-btn
          >
        </v-card-actions>
      </v-card>
    </template>
  </div>
</template>

<script>
import TituloModulo from "../../components/TituloModulo.vue";
import axios from "axios";

export default {
  components: {
    TituloModulo,
  },
  data: () => ({
    manuais: [],
    carregando: false,
  }),
  methods: {
    async getManuais() {
      this.carregando = true;
      this.manuais = [];
      await axios
        .get(`colaborador/manuais`)
        .then((res) => {
          if (res.data.success) this.manuais = res.data.data;
          else this.$toasted.error(res.data.msg);
        })
        .catch((e) => {
          this.$toasted.error(`Houve um erro ao carregar os manuais. ${e}`);
        })
        .finally(() => (this.carregando = false));
    },
  },
  mounted() {
    this.getManuais();
  },
};
</script>

<style>
</style>